import { useMemo, useState } from "react";
import { Alert, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useLocationEditOutletContext } from "../locationEditOutletContext";
import {
    getDefaultSelectableAssociationKind,
    getLocationAssociationTypeDef,
    LOCATION_ASSOCIATION_TYPES,
    type LocationAssociationKind,
} from "./locationAssociationRegistry";

const LocationAssociationsView = () => {
    const { locationId, locationName, metaDeleted } = useLocationEditOutletContext();
    const [selectedKind, setSelectedKind] = useState<LocationAssociationKind>(
        getDefaultSelectableAssociationKind
    );

    const selectedType = useMemo(
        () => getLocationAssociationTypeDef(selectedKind),
        [selectedKind]
    );

    const Panel = selectedType?.Panel;

    return (
        <div>
            <Form.Group className="mb-3" style={{ maxWidth: "24rem" }}>
                <Form.Label>Association type</Form.Label>
                <Form.Select
                    value={selectedKind}
                    onChange={(e) => setSelectedKind(e.target.value as LocationAssociationKind)}
                    aria-label="Association type"
                >
                    {LOCATION_ASSOCIATION_TYPES.map((type) => (
                        <option key={type.kind} value={type.kind} disabled={!type.selectable}>
                            {type.label}
                            {!type.selectable ? " (coming soon)" : ""}
                        </option>
                    ))}
                </Form.Select>
                {selectedType?.description && (
                    <Form.Text className="text-muted">{selectedType.description}</Form.Text>
                )}
                {LOCATION_ASSOCIATION_TYPES.some((t) => !t.selectable) && (
                    <Form.Text className="d-block text-muted mt-1">
                        Additional association types will be available here.
                    </Form.Text>
                )}
            </Form.Group>

            {metaDeleted && (
                <Alert variant="warning" className="mb-3">
                    This location is deleted. Restore it before adding or changing associations.
                </Alert>
            )}

            {Panel ? <Panel locationId={locationId} metaDeleted={metaDeleted} /> : null}

        </div>
    );
};

export { LocationAssociationsView };
